module.exports = __webpack_public_path__ + "img/ptr-logo.1f7d87c0.png";